export type ShareSource = "copy" | "email" | "sms" | "whatsapp";

/**
 * Build a desktop-share URL with the JSF `from=shareddesktop_<src>` analytics suffix.
 * Mirrors packages/jobsearch-ui/.../VjLinkShare-util.ts so backend share-source
 * attribution lines up between the JSF UI and the RN bundle embedded in JSF.
 */
export function buildShareableViewJobUrl(jobKey: string, src: ShareSource): string {
  if (typeof window === "undefined" || !jobKey) {
    return "";
  }
  const url = new URL("/viewjob", window.location.origin);
  url.searchParams.set("jk", jobKey);
  url.searchParams.set("from", `shareddesktop_${src}`);
  return url.toString();
}
